import React from "react";
import TimelineItem from "./TimelineItem";
import { GraduationCap } from "lucide-react";

const Education: React.FC = () => {
  const educationItems = [
    {
      title: "Software Engineering Program",
      organization: "1337 School",
      period: "2020 - 2023",
      location: "Morocco",
      description:
        "Intensive project-based software engineering program focused on practical skills development.",
      highlights: [
        "Completed rigorous peer-to-peer learning curriculum",
        "Developed multiple full-stack applications during the program",
        "Specialized in web and mobile development technologies",
        "Participated in coding competitions and hackathons",
      ],
      isLast: true,
    },
  ];

  const certifications = [
    {
      title: "Advanced React",
      organization: "Meta",
      period: "Issued Apr 2025",
      description:
        "Comprehensive certification covering advanced React concepts, state management, hooks, and optimization techniques.",
      credentialUrl: "https://coursera.org/verify/BXND6F7FMTR0",
    },
    {
      title: "Software Engineering Program",
      organization: "1337 School",
      period: "Completed 2023",
      description:
        "Intensive project-based software engineering curriculum focused on practical development skills and peer learning.",
      isLast: true,
    },
  ];

  return (
    <section id="education" className="py-20 bg-white">
      <div className="container-custom">
        <div className="flex items-center mb-8">
          <GraduationCap size={28} className="text-portfolio-blue mr-3" />
          <h2 className="section-title mb-0">Education</h2>
        </div>

        <div className="mt-10">
          {educationItems.map((item, index) => (
            <TimelineItem
              key={index}
              title={item.title}
              organization={item.organization}
              period={item.period}
              location={item.location}
              description={item.description}
              highlights={item.highlights}
              isLast={item.isLast || index === educationItems.length - 1}
            />
          ))}
        </div>

        <h3 className="text-xl font-semibold text-portfolio-blue mt-16 mb-6">
          Certifications & Additional Education
        </h3>

        <div className="mt-6">
          {certifications.map((cert, index) => (
            <TimelineItem
              key={index}
              title={cert.title}
              organization={cert.organization}
              period={cert.period}
              description={cert.description}
              isLast={cert.isLast || index === certifications.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
